import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalCustomContentConnectModules: ExperimentalQueries['experimentalCustomContentConnectModules'] =
	(_, __, { network }) =>
		fetchJSON(network, '/wiki/rest/atlassian-connect/1/modules/customContent', {
			method: 'GET',
			headers: {
				'Content-Type': MediaType.JSON,
			},
		}).then((json) => ({
			modules: json,
		}));
